import n from "./ownerDocument.mjs";
function r(o) {
  return n(o).defaultView || window;
}
export {
  r as default
};
//# sourceMappingURL=ownerWindow.mjs.map
